// extracted by mini-css-extract-plugin
export default {"invalid":"InputSection_invalid__27+lQ","link":"InputSection_link__E4qUP"};